import * as React from "react";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {Field} from "../form/Field";
import {PageContent} from "../Layout";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import _ = require("lodash");
import {enums} from "../../Enums";
import {getEnumOptions} from "../../utils/helper";
import {Checkbox} from "../form/fields/Checkbox";
import {Row, Col} from "reactstrap";

export class PrivilegeFormData {
    @observable role_id = '';
    @observable privileges = null;
    @observable isSaved:boolean = false;
}

export class PrivilegeForm extends CrudForm {
    modelName = 'Privilege';
    @observable modulePrivileges: any;
    @observable isSaved: boolean = false;
    onChangeRole = () => {
        this.formStore.getValue('role_id') && api.privilege.getAction({
            role_id: this.formStore.getValue('role_id'),
        }).then((data: any) => {
            this.modulePrivileges = data.data;
            this.formStore.setValue('privileges', _.keyBy(data.data, 'module'));
        });
    };

    postData = (data: any) => {
        return api.privilege.postFormAction('', data).then((response: any) => {
           this.isSaved = true;
        });
    };

    onCloseAlert = () => {
        this.isSaved = false;
    };

    renderFields() {
        const groupPermissions = this.formStore.getValue('privileges') ? _.groupBy(this.modulePrivileges, 'group') : {};
        const groupKeys = groupPermissions ? Object.keys(groupPermissions) : [];
        return (

            <>
                 <div className="row">
                    <div className="col-md-6">
                        <Field
                            label="Role"
                            name="role_id"
                            component={Select}
                            loadOptions={api.role.getListAction}
                            required={true}
                            store={this.formStore}
                            onChange={this.onChangeRole}
                        />
                    </div>
                </div>

                {
                    this.formStore.getValue('privileges') ? groupKeys.map((groupTitle: string, groupId: number) => {
                        return (
                            <div className="table-responsive" key={'group' + groupId}>
                                <table key={'group-table' + groupId} className="grid table table-hover">
                                    <thead key={'group-head' + groupId}>
                                    <tr key={'group-head-tr' + groupId}>
                                        <th key={'header-column-title' + groupId} style={{'width': "40%"}}>
                                            {groupTitle}
                                        </th>
                                        {
                                            getEnumOptions(enums.permissionType).map((permissionTypeObj: any,) => {
                                                return (
                                                    <th style={{'width': "15%"}}
                                                        key={'header-column-permission' + groupId + '-' + permissionTypeObj.value}>
                                                        {_.upperFirst(permissionTypeObj.label)}
                                                    </th>);
                                            })
                                        }
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        groupPermissions[groupTitle].map((module: any, i: number) => {
                                            const permissions = Object.keys(module.permissions);
                                            return (

                                                <tr key={'module-row-' + groupId + '-' + groupId + i + ''}>
                                                    <td>
                                                        {module.title}
                                                    </td>
                                                    {
                                                        permissions.map((permission: any, permissionIndex: number) => {
                                                            return (
                                                                <td key={module.module + '-' + permission + '-container'}>
                                                                    <Field
                                                                        key={module + '-' + groupId + permission}
                                                                       // name={"privileges." + module.module + ".permissions." + permission}
                                                                        name={"privileges." + module.module + ".permissions." + permission}
                                                                        component={Checkbox}
                                                                        required={true}
                                                                        store={this.formStore}
                                                                    />
                                                                </td>
                                                                )
                                                        })
                                                    }

                                                </tr>
                                            )
                                        })
                                    }


                                    </tbody>
                                </table>
                            </div>
                        )
                    }) : ''
                }

                {
                    this.isSaved ?
                        <Row className="form-row">
                            <Col md={12}>
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <button type="button" className="close" onClick={this.onCloseAlert}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    Privileges saved successfully!
                                </div>
                            </Col>
                        </Row> : ''
                }
                
            </>
        );
    }
}

export class PrivilegePage extends React.Component {
    modelName = 'Privilege';

    render() {
        return (
            <>
                <PageContent>
                    <PrivilegeForm
                    />
                </PageContent>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PrivilegePage.tsx